export function initProcessSliderBlocks() {
	const blocks = document.querySelectorAll('[data-process-slider]');
	if (!blocks.length) {
		return;
	}

	blocks.forEach((block) => {
		initProcessSliderBlock(block);
	});
}

function initProcessSliderBlock(block) {
	const track = block.querySelector('[data-process-track]');
	const prevButton = block.querySelector('[data-process-prev]');
	const nextButton = block.querySelector('[data-process-next]');
	if (!track || !prevButton || !nextButton) {
		return;
	}

	const getSlides = () => Array.from(track.querySelectorAll('.process-slider-block__slide'));

	const getSlideLeft = (slide) => {
		const trackRect = track.getBoundingClientRect();
		const slideRect = slide.getBoundingClientRect();
		return track.scrollLeft + (slideRect.left - trackRect.left);
	};

	const getPositions = () => {
		const slides = getSlides();
		if (!slides.length) return [];
		const positions = slides.map((slide) => Math.max(0, Math.round(getSlideLeft(slide))));
		return Array.from(new Set(positions)).sort((a, b) => a - b);
	};

	const getCurrentPositionIndex = (positions) => {
		if (!positions.length) return -1;
		const current = track.scrollLeft;
		let closest = 0;
		let minDistance = Number.POSITIVE_INFINITY;

		positions.forEach((position, index) => {
			const distance = Math.abs(position - current);
			if (distance < minDistance) {
				minDistance = distance;
				closest = index;
			}
		});

		return closest;
	};

	const updateNavState = () => {
		const positions = getPositions();
		if (!positions.length) {
			prevButton.disabled = true;
			nextButton.disabled = true;
			return;
		}

		const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
		if (maxScroll <= 2) {
			prevButton.disabled = true;
			nextButton.disabled = true;
			return;
		}

		const currentIndex = getCurrentPositionIndex(positions);
		prevButton.disabled = currentIndex <= 0;
		nextButton.disabled = currentIndex >= positions.length - 1;
	};

	const scrollByDirection = (direction) => {
		const positions = getPositions();
		if (!positions.length) return;

		const currentIndex = getCurrentPositionIndex(positions);
		if (currentIndex < 0) return;

		const delta = direction > 0 ? 1 : -1;
		const targetIndex = Math.min(Math.max(currentIndex + delta, 0), positions.length - 1);
		track.scrollTo({ left: positions[targetIndex], behavior: 'smooth' });
	};

	prevButton.addEventListener('click', () => {
		scrollByDirection(-1);
	});

	nextButton.addEventListener('click', () => {
		scrollByDirection(1);
	});

	track.addEventListener('scroll', updateNavState, { passive: true });
	window.addEventListener('resize', updateNavState);

	updateNavState();
}
